import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_MONEDAS,
  ALL_MONEDAS,
  LOADING_ALL_MONEDAS,
} from './MonedasReducer';
import {
  allMonedasService,
  deleteMonedasService,
  oneMonedasService,
  saveMonedasService,
} from './MonedasService';

export const allMonedasAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_MONEDAS, payload: true });
    const res = await allMonedasService(params);
    dispatch({ type: ALL_MONEDAS, payload: res.data });
    dispatch({ type: LOADING_ALL_MONEDAS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_MONEDAS, payload: false });
    tryCatchHelper(e);
  }
};

export const saveMonedasAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveMonedasService(id, data);
    notify(res.data.message);
    await allMonedasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoMonedasAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_MONEDAS, payload: data });
};

export const oneMonedasAction = async (dispatch, id) => {
  try {
    const res = await oneMonedasService(id);
    await setActivoMonedasAction(dispatch, res.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteMonedasAction = async ({ dispatch, notify }, id, params) => {
  try {
    const res = await deleteMonedasService(id);
    await setActivoMonedasAction(dispatch, null);
    notify(res.data.message);
    await allMonedasAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
